import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import AgencyFilterHeader from './AgencyFilterHeader';
import AgencyFilterResults from './AgencyFilterResults';
import scrollTop from '../../../utils/helpers/smoothScroll';

const AgencyFilter = ({ categories = [], allCategories = [], agencyId }) => {
  const { t } = useTranslation();
  const wrapperRef = useRef(null);
  const [category, setCategory] = useState({
    id: 'all'
  });
  const [activeLeasedCategory, setActiveLeasedCategory] = useState([
    'lease',
    'sale'
  ]);
  const combinedCategories = [
    ...[
      {
        id: 'lease',
        pluralName: t('pages.agency.lease')
      },
      {
        id: 'sale',
        pluralName: t('pages.agency.sale')
      }
    ],
    ...categories
  ].map(categ => {
    let title = null;

    // eslint-disable-next-line  array-callback-return
    allCategories.some(item => {
      if (item.children.length) {
        const foundArr = item.children.filter(child => child.id === categ.id);

        if (foundArr.length) {
          // eslint-disable-next-line  prefer-destructuring
          title = foundArr[0].title;
          return true;
        }
      }

      if (item.id === categ.id) {
        // eslint-disable-next-line  prefer-destructuring
        title = item.title;
      }
    });

    return {
      ...categ,
      title
    };
  });

  const onClickFilterItem = (id, isSetLeasedCategories = true) => {
    if (wrapperRef.current) {
      scrollTop(
        document.documentElement || document.scrollingElement || document.body,
        wrapperRef.current.offsetTop
      );
    }
    setCategory({ id });
    isSetLeasedCategories && setActiveLeasedCategory(['lease', 'sale']);
  };

  return (
    <section className="agency-filter" ref={wrapperRef}>
      <AgencyFilterHeader
        categories={combinedCategories}
        activeCategoryId={category.id.toString()}
        onClickItem={onClickFilterItem}
      />
      <AgencyFilterResults
        agencyId={agencyId}
        categories={combinedCategories}
        activeCategoryId={category.id.toString()}
        onClickItem={onClickFilterItem}
        activeLeasedCategory={activeLeasedCategory}
        setActiveLeasedCategory={setActiveLeasedCategory}
      />
    </section>
  );
};

AgencyFilter.displayName = `AgencyFilter`;

AgencyFilter.propTypes = {
  categories: PropTypes.array,
  agencyId: PropTypes.string,
  allCategories: PropTypes.array
};

export default AgencyFilter;
